<script>
import axios from '@/utils/axios';
import { useToast } from 'vue-toastification';

export default {
  inject: ['setLoading'],
  data() {
    return {
      title: "User Management",
      text: "User Management",
      text1: "Users",
      toast: useToast(),
      data: [],
      roles: [],
      industries: [],
      pagination: {
        current_page: 1,
        last_page: 1,
        total: 0,
        links: []
      },
    };
  },

  mounted() {
    this.getRoles();  
    this.getIndustries();
    this.admins();
  }, 

  methods: {
    async getRoles() {
     this.setLoading(true);
     try{
      const response = await axios.get('/roles');
      this.roles = response.data.data;
     }catch(error){
      this.toast.error(error.message);
     }finally{
      this.setLoading(false);
     }
    },

    async getIndustries(){
     this.setLoading(true);
     try{
      const response = await axios.get('/industries');
      this.industries = response.data.data;
     }catch(error){
      this.toast.error(error.message);
     }finally{
      this.setLoading(false);
     }
    },

    async admins(page = 1){
     this.setLoading(true);
     try{
      const response = await axios.get(`/users?page=${page}`);
      this.data = response.data.data.data;
      this.pagination = {
       current_page: response.data.data.current_page,
       last_page: response.data.data.last_page,
       total: response.data.data.total,
       links: response.data.data.links
      };
     }catch(error){
      this.toast.error(error.message);
     }finally{
      this.setLoading(false);
     }
    },

    changePage(url){
     if (!url) return;
     const page = new URL(url).searchParams.get("page");
     this.admins(page);
    },
  },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
  <div class="content">
    <!-- Breadcrumb -->
    <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <breadcrumb :title="title" :text="text" :text1="text1" />
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
        
        <!-- <div class="me-2 mb-2">
        <div class="dropdown">
        <a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown">
        <i class="ti ti-file-export me-1"></i>Export
        </a>
        <ul class="dropdown-menu dropdown-menu-end p-3">
        <li>
            <a href="javascript:void(0);" class="dropdown-item rounded-1"><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a>
        </li>
        <li>
            <a href="javascript:void(0);" class="dropdown-item rounded-1"><i class="ti ti-file-type-xls me-1"></i>Export as Excel</a>
        </li>
        </ul>
        </div>
        </div> -->
        
        <div class="mb-2">
          <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#admin_modal" class="btn btn-primary d-flex align-items-center" @click="$refs.adminModal.add();">
            <i class="ti ti-circle-plus me-2"></i>Add Admin
          </a>
        </div>
        
      </div>
    </div>
    <!-- /Breadcrumb -->

    <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
    <h5>Users List</h5>
    <!-- <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
        <div class="me-3">
        <div class="input-icon-end position-relative">
        <input type="text" class="form-control date-range bookingrange" ref="dateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy"/>
        <span class="input-icon-addon">
        <i class="ti ti-chevron-down"></i>
        </span>
        </div>
        </div>
        <div class="dropdown me-3">
        <a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown">Role</a>
            <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
                <a href="javascript:void(0);" class="dropdown-item rounded-1">Employee</a>
            </li>
            <li>
                <a href="javascript:void(0);" class="dropdown-item rounded-1">Client</a>
            </li>
            </ul>
        </div>
        <div class="dropdown me-3">
            <a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
            data-bs-toggle="dropdown">
            Status
            </a>
            <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
                <a href="javascript:void(0);" class="dropdown-item rounded-1">Active</a>
            </li>
            <li>
                <a href="javascript:void(0);" class="dropdown-item rounded-1">Inactive</a>
            </li>
            </ul>
        </div>
        <div class="dropdown">
            <a
            href="javascript:void(0);"
            class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
            data-bs-toggle="dropdown"
            >
            Sort By : Last 7 Days
            </a>
            <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
                <a href="javascript:void(0);" class="dropdown-item rounded-1">Recently Added</a>
            </li>
            <li>
                <a href="javascript:void(0);" class="dropdown-item rounded-1">Ascending</a>
            </li>
            <li>
                <a href="javascript:void(0);" class="dropdown-item rounded-1">Desending</a>
            </li>
            <li>
                <a href="javascript:void(0);" class="dropdown-item rounded-1">Last Month</a>
            </li>
            <li>
                <a href="javascript:void(0);" class="dropdown-item rounded-1">Last 7 Days</a>
            </li>
            </ul>
        </div>
        </div> -->
    </div>
      <div class="card-body p-0">
        <div class="custom-datatable-filter table-responsive">
          <table class="table datatable thead-light" v-if="data.length">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in data" :key="row.id">
                <td>{{ index + 1 }}</td>  
                <td>{{ row.name }}</td>
                <td>{{ row.email }}</td>
                <td>{{ row.mobile }}</td>
                <td>

                  <div class="dropdown">
                  <button class="btn btn-icon btn-sm rounded-circle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="ti ti-dots-vertical"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                  <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#admin_modal" @click="$refs.adminModal.editAdmin(row)"><i class="ti ti-edit me-1"></i>Edit</a>
                  </li>
                  <li>
                  <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#delete_modal" @click="$refs.adminModal.editAdmin(row)"><i class="ti ti-trash me-1"></i>Delete</a>
                  </li>
                  </ul>
                  </div>  

                </td>
              </tr>
            </tbody>
          </table>

          <div v-else class="p-3 text-center text-muted">
            No records found.
          </div>
        </div>

        <!-- Pagination -->
        <nav v-if="pagination.links.length > 3" class="m-3">
          <ul class="pagination">
            <li v-for="(link, index) in pagination.links" :key="index"
              :class="['page-item', { active: link.active, disabled: !link.url }]">
              <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
  
</div>
<!-- /Page Wrapper -->

<admin-modal :roles="roles" :industries="industries" ref="adminModal" @updated="admins"></admin-modal>
</template>
